export default "__VITE_ASSET__f031e020__"